import logger from '../utils/logger';
import React, { useState, useEffect, useContext } from "react";
import "../style/PatientInsuranceForm.css";
import { GlobalStateContext } from "../utils/GlobalStateContext";
import { getUserId } from "../utils/utils";

export default function PatientInsuranceModal({ 
  isOpen, 
  onClose, 
  initialData = {} 
}) {

  const [plans, setPlans] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const {currentPatient} = useContext(GlobalStateContext);
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);

  const [form, setForm] = useState({
    insuranceType: initialData.insuranceType || "",
    relationship: initialData.relationship || "",
    insured: initialData.insured || "",
    effectiveDate: initialData.effectiveDate || "",
    terminationDate: initialData.terminationDate || "",
    notes: initialData.notes || "",
    planId: initialData.planId || "",
    memberId: initialData.memberId || "",
    groupNumber: initialData.groupNumber || "",
    copay: initialData.copay || "",
    ris_patients_id: currentPatient.patient[0].ris_patients_id,
  });

  // Fetch plans from backend
  useEffect(() => {
    if (!isOpen) return; // only fetch when modal is open
    const fetchPlans = async () => {
      try {
        const res = await fetch(`${BASE_URL}/billing/getInsurancePlans`);
        if (!res.ok) throw new Error("Failed to fetch plans");
        const data = await res.json();
        setPlans(data);
      } catch (err) {
        logger.error("Error fetching plans:", err);
      }
    };

    fetchPlans();
  }, [isOpen, BASE_URL]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // logger.log("Saving Patient Insurance:", form);

    try {
      const res = await fetch(`${BASE_URL}/billing/addPatientInsurance`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({form, type: currentPatient.type, user}),
      });

      if (!res.ok) throw new Error("Failed to save insurance");
      const saved = await res.json();
      // logger.log("Saved:", saved);
      onClose(); // close modal after save
    } catch (err) {
      logger.error(err);
    }
  };

  // const handleDelete = async () => {
  //   if (!form.id) {
  //     alert("No insurance record to delete.");
  //     return;
  //   }

  //   try {
  //     const res = await fetch(`${BASE_URL}/patient-insurance/${form.id}`, {
  //       method: "DELETE",
  //     });

  //     if (!res.ok) throw new Error("Failed to delete insurance");
  //     logger.log(`Deleted insurance ID: ${form.id}`);
  //     onClose();
  //   } catch (err) {
  //     logger.error(err);
  //   }
  // };

  if (!isOpen) return null;

  return (
    <div className="patient-insurance-modal-overlay">
      <div className="patient-insurance-modal-container">
        <h2>Add Insurance to Patient</h2>
        <form className="patient-insurance-form" onSubmit={handleSubmit}>
          {/* Left side */}
          <div className="patient-insurance-form-section">
            <label>
              Insurance Type:
              <select
                name="insuranceType"
                value={form.insuranceType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="primary">Primary Insurance</option>
                <option value="secondary">Secondary Insurance</option>
                <option value="tertiary">Tertiary Insurance</option>
              </select>
            </label>

            <label>
              Relationship to Insured:
              <select
                name="relationship"
                value={form.relationship}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="self">Self</option>
                <option value="spouse">Spouse</option>
                <option value="child">Child</option>
                <option value="other">Other</option>
              </select>
            </label>

            <label>
              Insured:
              <input
                type="text"
                name="insured"
                value={form.insured}
                onChange={handleChange}
                placeholder="Enter Insured Name"
              />
            </label>

            <label>
              Effective Date:
              <input
                type="date"
                name="effectiveDate"
                value={form.effectiveDate}
                onChange={handleChange}
              />
            </label>

            <label>
              Termination Date:
              <input
                type="date"
                name="terminationDate"
                value={form.terminationDate}
                onChange={handleChange}
              />
            </label>
          </div>

          {/* Right side */}
          <div className="patient-insurance-form-section">
            <label>
              Plan:
              <select
                name="planId"
                value={form.planId}
                onChange={handleChange}
                required
              >
                <option value="">-- Select a Plan --</option>
                {plans.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.plan_name}
                  </option>
                ))}
              </select>
            </label>

            <label>
              Member ID:
              <input
                type="text"
                name="memberId"
                value={form.memberId}
                onChange={handleChange}
                placeholder="Enter Member ID"
              />
            </label>

            <label>
              Group Number:
              <input
                type="text"
                name="groupNumber"
                value={form.groupNumber}
                onChange={handleChange}
                placeholder="Enter Group Number"
              />
            </label>

            <label>
              Co-Pay:
              <input
                type="text"
                name="copay"
                value={form.copay}
                onChange={handleChange}
                placeholder="Enter Co-Pay"
              />
            </label>

            <label>
              Notes:
              <input
                type="text"
                name="notes"
                value={form.notes}
                onChange={handleChange}
                placeholder="Enter Notes"
              />
            </label>

            {/* <label>
              MSP Type:
              <select
                name="mspType"
                value={form.mspType}
                onChange={handleChange}
              >
                <option value="">Select MSP Type</option>
                <option value="working-aged">Working Aged</option>
                <option value="disabled">Disabled</option>
                <option value="end-stage-renal">
                  End-Stage Renal Disease
                </option>
              </select>
            </label> */}
          </div>
        </form>

        {/* Buttons */}
        <div className="patient-insurance-form-actions">
          <button 
            className="insurance-btn-primary insurance-btn" 
            type="submit" 
            onClick={handleSubmit}
          >
            Save New Insurance
          </button>
          
          <button 
            type="button" 
            onClick={onClose} 
            className="cancel-btn"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
